import { ChangeEvent, FormEvent } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { Form } from 'formik';

import { CustomInput } from 'src/components/CustomInput';
import { PaymentDetailsFormValues } from 'src/types/ViewPartner/EditPaymentDetails';

type EditPaymentDetailsFormProps = {
    handleChange: {
        (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
        <T = string | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>>(
            field: T
        ): T extends ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ? void
            : (e: string | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    };
    handleSubmit: (e?: FormEvent<HTMLFormElement>) => void;
    values: PaymentDetailsFormValues;
    handleClose: () => void;
    message: string;
    buttonText?: string;
    closeModalButtonText?: string;
};

const EditPaymentDetailsForm = (props: EditPaymentDetailsFormProps) => {
    const {
        handleChange,
        handleSubmit,
        values,
        handleClose,
        message,
        buttonText,
        closeModalButtonText,
    } = props;
    return (
        <Form
            onSubmit={(e: FormEvent<HTMLFormElement>) => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                <Typography
                    sx={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#000',
                    }}
                >
                    Edit Payment Details
                </Typography>

                {message && <Typography>{message}</Typography>}

                <CustomInput
                    name="bic"
                    label="BIC"
                    value={values.bic}
                    onChange={handleChange}
                    boxStyling={{
                        width: '100%',
                    }}
                />

                <CustomInput name="iban" label="IBAN" value={values.iban} onChange={handleChange} />

                <Stack direction="row" justifyContent="space-between" gap={2} sx={{ mt: 3 }}>
                    <Button
                        variant="outlined-black"
                        onClick={handleClose}
                        sx={{ width: '100%', height: '44px' }}
                    >
                        {closeModalButtonText}
                    </Button>

                    <Button type="submit" variant="main" sx={{ width: '100%', height: '44px' }}>
                        {buttonText}
                    </Button>
                </Stack>
            </Box>
        </Form>
    );
};

export default EditPaymentDetailsForm;
